// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const zaaptvColors: ColorType = {
  ...colorPalette,
  primary: '#f38931',
  signColor: '#f38931',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: zaaptvColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: zaaptvColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: zaaptvColors.primaryGray,
    secondary: zaaptvColors.secondaryGray,
    disabled: zaaptvColors.grayText,
    link: zaaptvColors.secondaryGray,
    hint: zaaptvColors.white,
    highlight: zaaptvColors.secondary,
    gray: zaaptvColors.primaryGray,
    seeAll: zaaptvColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: zaaptvColors.primaryGray,
    gray: zaaptvColors.secondaryGray,
  },
  filter: {
    primary: zaaptvColors.primaryGray,
    secondary: zaaptvColors.secondaryGray,
    disabled: zaaptvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: zaaptvColors.dark,
    color: zaaptvColors.white,
    border: zaaptvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: zaaptvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: zaaptvColors.dark,
        selected: zaaptvColors.dark,
        progress: rgba(zaaptvColors.primary, 0.3),
        past: rgba(zaaptvColors.primary, 0.3),
        pastSelected: zaaptvColors.dark,
        pastHover: zaaptvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(zaaptvColors.primary, 0.1),
      },
      text: {
        empty: zaaptvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: zaaptvColors.white,
    subTitle: zaaptvColors.secondaryGray,
    bg: zaaptvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
